import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_TEST_MANAGEMENT } from "../../../route/teacherRoute";
import "./style.sass";

export const SuccessModal = ({
  testName = "NEET Biology Mock Test – 01",
  onClose,
  onGoToQuestionPapers,
}) => {
  const navigate = useNavigate();

  return (
    <div className="success_modal_overlay" onClick={onClose}>
      <div className="success_modal_box" onClick={(e) => e.stopPropagation()}>
        <svg
          className="close_btn"
          onClick={onClose}
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#6B7280"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>

        {/* Success Green Check Circle */}
        <div className="success_circle">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h2>Question Paper Added Successfully!</h2>
        <p className="success_subtitle">
          Your question paper has been created and added to your question paper list.
        </p>

        {/* Test Name Card */}
        <div className="test_info_card">
          <div className="doc_badge">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#612EF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
          </div>
          <div className="info_text">
            <span className="label">Test Name</span>
            <span className="value">{testName}</span>
          </div>
        </div>

        <p className="note_text">
          You can edit, assign or conduct this test from the Test Management page.
        </p>

        {/* Action Buttons */}
        <div className="action_buttons">
          <button
            className="secondary_btn"
            onClick={() => {
              onClose();
              if (onGoToQuestionPapers) onGoToQuestionPapers();
            }}
          >
            Go to Question Papers
          </button>
          <button
            className="primary_btn"
            onClick={() => {
              onClose();
              navigate(ROUTE_TEST_MANAGEMENT);
            }}
          >
            Proceed to Test Management Page
          </button>
        </div>
      </div>
    </div>
  );
};
